import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import useForm from 'assets/components/form/hooks/Form';
import FileInputSimple from 'assets/components/inputs/file/FileInputSimple';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { Fragment, useMemo } from 'react';

export default function ClaimDocumentForm(props: {
  onSubmit: (docs: Array<Utils.FormData<Model.IClaimDocument>>) => void;
}) {
  const { lang } = getLocales();

  const docForm = useForm<{ documents: Array<Utils.FormData<Omit<Model.IClaimDocument, 'claimId'>>> }>({
    default: { documents: [] },

    onSubmit: async ({ documents }) => {
      props.onSubmit(documents);
      docForm.reload();
    },
    validation: (data, errors) => {
      if (data.documents?.some((it) => !it.name)) errors.documents = { name: lang.required };
    },
  });
  const uploadedFiles = useMemo(
    () =>
      docForm.data?.documents?.map((doc) => ({
        original: doc.formFile,
        type: doc.formFile.type as Utils.File.MimeType,
        dataUrl: window.URL.createObjectURL(doc.formFile),
        name: doc.name,
        notes: doc.notes,
      })),
    [docForm.data.documents]
  );

  return (
    <>
      <InputWrapper>
        <FileInputSimple
          name="files"
          value={uploadedFiles}
          onChange={({ files }) => {
            docForm.update({
              documents: [
                ...(docForm.data.documents ?? []),
                ...files.map((file) => ({
                  formFile: file.original,
                  name: file.original?.name,
                })),
              ],
            });
          }}
          label={lang.documentUpload}
        />

        <Button
          render={lang.add}
          onClick={docForm.submit}
          active={!docForm.hasErrors}
          class={ThemeButtonCircle}
          style={{ flexShrink: 0 }}
          disabled={docForm.hasErrors || docForm.isSubmitted || !docForm.isUpdated || !docForm.data?.documents?.length}
        />
      </InputWrapper>
      <DataMap
        data={docForm.data.documents ?? []}
        render={({ data: uploadedFile, index }) => (
          <Fragment key={index}>
            <br />
            <br />
            <InputWrapper>
              <TextInput
                name="name"
                label={lang.name}
                value={uploadedFile.name}
                error={!uploadedFile.name ? lang.required : undefined}
                onChange={(data) => {
                  docForm.data.documents[index] = { ...docForm.data.documents[index], ...data };
                  docForm.update({ documents: [...docForm.data.documents] });
                }}
              />
              <TextInput
                name="notes"
                label={lang.notes}
                value={uploadedFile.notes}
                onChange={(data) => {
                  docForm.data.documents[index] = { ...docForm.data.documents[index], ...data };
                  docForm.update({ documents: [...docForm.data.documents] });
                }}
              />
            </InputWrapper>
          </Fragment>
        )}
      />
    </>
  );
}
